import styled from 'styled-components';
import Soccer from '../../../common/components/js/sports/Soccer';

interface IProps {
  j1League: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
  };

  jLeagueCup: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
  };

  overseas: {
    isShow: boolean;
    players?: Array<{
      url: string;
      name: string;
    }>;
  };

  hasTitle: boolean; // モジュールタイトルを表示する
}
const SoccerWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
`;

const TopSoccer: React.FC<IProps> = props => {
  if (!props.j1League.isShow && !props.jLeagueCup.isShow && !props.overseas.isShow) {
    return null;
  }
  return (
    <SoccerWrapper>
      <Soccer
        j1League={props.j1League}
        jLeagueCup={props.jLeagueCup}
        overseas={props.overseas}
        hasTitle={props.hasTitle}
      />
    </SoccerWrapper>
  );
};

export default TopSoccer;
